<template>
  <div class="bom-item-add-alternate-part-form" style="display: inline-block;">
    <Button type="primary" @click="handleAddAlternateClick" :disabled="readonly">{{ $t('bom_tool.add_alternate_part') }}</Button>
    <Modal v-model="showForm" :title="$t('bom_tool.add_alternate_part')" width="820" ok-text="Submit" @on-ok="handleSubmit">
      <Form :model="formData" ref="bomItemAddAlternateForm" label-position="top">
        <FormItem :label="$t('bom_tool.search_part')">
          <ManufacturerPartPicker :disabled="disableFilter"
                                  v-model="formData.manufacturer_part_id"
                                  :manufacturer-part.sync="manufacturerPart"
                                  :label="false">
          </ManufacturerPartPicker>
        </FormItem>
        <FormItem :label="$t('bom_tool.preferred_status')">
          <RadioGroup v-model="formData.preferred_status">
            <Radio label="preferred">{{ $t('bom_tool.preferred') }}</Radio>
            <Radio label="alternate">{{ $t('bom_tool.alternate') }}</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem :label="$t('option')">
          <RadioGroup v-model="formData.option">
            <Radio label="current_bom">{{ $t('bom_tool.current_bom_only') }}</Radio>
            <Radio label="global">{{ $t('bom_tool.global_substitute') }}</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem :label="$t('bom_tool.global_substitute_setting')" v-if="formData.option === 'global'">
          <RadioGroup v-model="formData.substitute_config">
            <Radio label="mutual_substitute">{{ $t('part.mutual_substitute') }}</Radio>
            <Radio label="unilateral_substitute">{{ $t('part.unilateral_substitute') }}</Radio>
          </RadioGroup>
        </FormItem>
        <Row>
          <Col span="10">
          <Card>
            <p slot="title">
              <span v-if="formData.alternate">{{ formData.alternate.mpn }} {{ formData.alternate.brand }}</span>
              <span v-else>{{ $t('not_available') }}</span>
            </p>
            <p v-if="formData.alternate">{{ formData.alternate.specification }}</p>
            <p v-else>Nothing to show, please search a part from above first.</p>
          </Card>
          </Col>
          <Col span="4" style="text-align: center; vertical-align: middle; line-height: 51px;">
            <Icon size="42" :type="substituteIcon"></Icon>
          </Col>
          <Col span="10">
            <Card v-if="formData.base">
              <p slot="title">{{ formData.base.mpn }} {{ formData.base.brand }}</p>
              <p>{{ formData.base.specification }}</p>
            </Card>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
            <Button type="primary" :loading="submtting" @click="handleSubmit" :disabled="!formData.alternate">Submit</Button>
        </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ManufacturerPartPicker from '@/view/part/components/manufacturer-part-picker'
export default {
  name: 'BOMItemAddAlternatePartForm',
  components: {
    ManufacturerPartPicker
  },
  props: {
    basePart: Object,
    alternatePart: Object,
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    substituteIcon () {
      return (this.formData.option === 'current_bom' || this.formData.substitute_config === 'unilateral_substitute')
        ? 'md-arrow-forward'
        : 'md-swap'
    }
  },
  data () {
    return {
      submtting: false,
      formData: {
        preferred_status: 'alternate',
        option: 'current_bom',
        substitute_config: 'unilateral_substitute',
        base: this.basePart,
        alternate: this.alternatePart
      },
      manufacturerPart: {},
      showForm: false,
      disableFilter: false
    }
  },
  methods: {
    ...mapActions(['saveBomItemPluginData']),
    refresh ({ base = null, alternate = null, option = 'current_bom', substitute_config = 'unilateral_substitute', preferred_status = 'alternate' }, disableFilter = false) {
      this.formData = Object.assign({}, this.formData, {
        base: base,
        alternate: alternate,
        preferred_status: preferred_status,
        option: option,
        substitute_config: substitute_config,
        manufacturer_part_id: alternate?.manufacturer_part?.manufacturer_part_id
      })
      this.manufacturerPart = alternate?.manufacturer_part
      this.disableFilter = disableFilter
    },
    handleAddAlternateClick () {
      this.showForm = true
      this.refresh({ base: this.basePart }, false)
    },
    handleSubmit () {
      const data = Object.assign({}, this.formData, {
        manufacturer_part_id: this.formData.alternate?.manufacturer_part_id || this.formData.manufacturer_part_id,
        bom_item_id: this.basePart.id
      })
      this.submtting = true
      return this.saveBomItemPluginData({ plugin: 'alternates', itemId: this.basePart.id, data: data }).then(resp => {
        this.showForm = false
        this.$emit('on-saved', resp.data)
      }).finally(() => {
        this.submtting = false
      })
    }
  },
  watch: {
    'formData.manufacturer_part_id': function () {
      this.formData.alternate = this.manufacturerPart
    }
  }
}
</script>
